import withDraft from '@/utils/draftHelper';
import actions from '@/search/constants';
import { updateAuditName } from './state';

const updateSearchName = withDraft((draft, { code, result: { name } }) => {
  updateAuditName(draft, 'search', code, name);
});

export default {
  [actions.EDIT_SEARCH]: updateSearchName,
};
